import { useState } from 'react';
import { useT } from '@/shared/i18n/useT';
import { signOut } from './passwordAuth';

/**
 * Ends the session on this domain.
 *
 * Only the action is shared between the two shells; each Settings screen still
 * owns its own layout and wraps this in its own card. Signing out of
 * procalendar.app leaves a numtable.com session alone, and vice versa — the two
 * are stored under different keys and are meant to be independent
 * (docs/ARCHITECTURE.md §2).
 */
export function SignOutButton({ onSignedOut }: { onSignedOut?: () => void }) {
  const t = useT();
  const [busy, setBusy] = useState(false);

  async function handleClick() {
    setBusy(true);
    try {
      await signOut();
      onSignedOut?.();
    } finally {
      // The provider flips to signedOut through onAuthStateChange, which
      // usually unmounts this button; resetting matters when it does not,
      // such as when signOut failed and the user should be able to retry.
      setBusy(false);
    }
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={busy}
      className="nt-control"
    >
      {busy ? t('auth.session.signOutPending') : t('auth.session.signOut')}
    </button>
  );
}
